import apiClient from '@/api/apiClient';

export default {
  bindVisitor(customerWebsiteUserToken) {
    return apiClient.post("/api/customer/app/bindVisitor", {
      customerWebsiteUserToken: customerWebsiteUserToken || null
    });
  },
};
